<template>
  <div>
    <button v-if="canGoBack" @click="goBack" class="btn btn-outline-secondary mt-3 mb-3">
      <i class="bi bi-arrow-left"></i> Назад
    </button>

    <div v-if="recipe">
      <RecipeView :recipe="recipe" />
    </div>
    <div v-else>
      <p>Загрузка рецепта...</p>
    </div>
  </div>
</template>

<script>
import RecipeView from "../RecipeView.vue";
const CMD_RECIPE_GET = "recipe.get/";

export default {
  name: "PageReciep",
  components: {
    RecipeView,
  },
  data() {
    return {
      recipe: null,
      canGoBack: false,
      currentRecipeId: null,
    };
  },
  mounted() {
    this.canGoBack = window.history.length > 1;
    this.handleRouteChange();
    window.addEventListener("hashchange", this.handleRouteChange);
  },
  beforeUnmount() {
    window.removeEventListener("hashchange", this.handleRouteChange);
  },
  methods: {
    goBack() {
      window.history.back();
    },
    handleRouteChange() {
      if (!window.location.hash.startsWith("#/recipes/")) {
        return;
      }
      const parts = window.location.hash.split("/");
      const recipeId = parts[parts.length - 1];

      if (recipeId && recipeId !== this.currentRecipeId) {
        this.currentRecipeId = recipeId;
        this.recipe = null; // Reset to show loading indicator
        this.whenLogin().then(() => {
          this.fetchRecipe(recipeId);
        });
      }
    },
    fetchRecipe(recipeId) {
      this.sendCmd(CMD_RECIPE_GET + recipeId)
        .then((data) => {
          try {
            this.recipe = JSON.parse(data);
          } catch (e) {
            console.error("Failed to parse recipe data:", e);
            this.recipe = null;
          }
        })
        .catch((err) => {
          console.error("Error fetching recipe:", err);
          this.recipe = null;
        });
    },
  },
};
</script>

<style scoped>
/* Add any specific styles here */
</style>
